
<div id="settingbackground">

  <nav>
    <img class="logo" src="../../assets/images/logo1.png">
    <div class="menu">
      <span></span>
      <ul>
        <li><a (click)="routerService.GoToSetting(id)">設定</a></li>
        <li><a (click)="routerService.GoToControl(id)">控制</a></li>
        <li><a (click)="routerService.GoToOverview(id)">播放清單</a></li>
        <li><a (click)="routerService.GoToLottery(id)">抽獎</a></li>
      </ul>
    </div>
  </nav>
</div>
<div id="setting-screen" *ngIf="checkIDState === 1">
  <div id="content" *ngIf="checkState === 1">
    <h6 id="title">
      設定
    </h6>
    <div id="min_money">
      <!-- 最低金額 -->
      <mat-form-field id="min_money1">
        <mat-label>最低Donate金額</mat-label>
        <input matInput type="number" [(ngModel)]="min_money" />
        <mat-hint align="end">請設定與歐富寶的最低金額相同</mat-hint>
      </mat-form-field>
      <br>
    </div>
    <!-- 請設定HASH -->
    <div class="opaySetting">
      <mat-form-field id="donatehash">
        <input matInput type="text" [(ngModel)]="opay_payment_hash" />
        <mat-label>請設定HASH</mat-label>
      </mat-form-field>
      <button id="hashget" mat-raised-button (click)="openDialog()">Hash取得教學</button>
    </div>
    <!-- <mat-form-field id="donatehash">
          <input matInput type="text" [(ngModel)]="opay_shopId" />
          <mat-label>商店代碼</mat-label>
        </mat-form-field>
        <br> -->
    <!-- <mat-form-field id="donatehash">
          <input matInput type="text" [(ngModel)]="opay_HashKey" />
          <mat-label>ALL IN ONE 介接 HashKey</mat-label>
        </mat-form-field>
        <br>
        <mat-form-field id="donatehash">
          <input matInput type="text" [(ngModel)]="opay_HashIV" />
          <mat-label>ALL IN ONE 介接 HashIV</mat-label>
        </mat-form-field>
      </div> -->
    <!-- 秒數倍率 -->
    <mat-form-field class="time" id="times">
      <input matInput type="number" [(ngModel)]="times" />
      <mat-label>秒數倍率</mat-label>
    </mat-form-field>
    <!-- 基礎秒數 -->
    <mat-form-field class="time" id="basetime">
      <input matInput type="number" [(ngModel)]="basetime" />
      <mat-label>基礎秒數</mat-label>
    </mat-form-field>
    <span id="timeCal">秒數倍率 * Donate金額 + 基礎秒數 = 影片時間</span>
    <!-- <span id="viewLimit">
      <span id="limitTitle">影片觀看數限制</span>
      <mat-slider thumbLabel id="limitSlider" [displayWith]="viewLimit"  [tickInterval]="1" [step]="1" tickInterval="1000" min="0" max="4" [(ngModel)]="youtubeRestrictionLevel"></mat-slider>
    </span>
    <span id="limitDescription">
      關閉：沒有任何安全性
      <br>
      低階：65% 正面評論，5000以上觀看數
      <br>
      中階：75% 正面評論，40000以上觀看數
      <br>
      高階：80% 正面評論，300K以上觀看數
      <br>
      極高階：85% 正面評論，900K以上觀看數
    </span> -->
    <!-- 背景圖片路徑 -->
    <div class="img">
      <mat-form-field id="donatebackground">
        <input matInput type="text" [(ngModel)]="img1" />
        <mat-hint align="end">建議比例4:3</mat-hint>
        <mat-label>背景圖片路徑</mat-label>
      </mat-form-field>
      <br>
      <!-- 標題LOGO路徑 -->
      <mat-form-field id="logo">
        <input matInput type="text" [(ngModel)]="img2" />
        <mat-hint align="end">建議比例3:1</mat-hint>
        <mat-label>標題LOGO路徑</mat-label>
      </mat-form-field>
      <br>
      <!-- 大頭貼路徑 -->
      <mat-form-field id="headicon">
        <input matInput type="text" [(ngModel)]="img3" />
        <mat-hint align="end">建議比例1:1</mat-hint>
        <mat-label>大頭貼路徑</mat-label>
      </mat-form-field>
      <br>
      <!-- Donate圖片 -->
      <mat-form-field id="donateimg">
        <input matInput type="text" [(ngModel)]="img4" />
        <mat-hint align="end">建議比例4:3</mat-hint>
        <mat-label>Donate圖片</mat-label>
      </mat-form-field>
      <br>
    </div>
    <!-- donate頁面介紹 -->
    <mat-form-field id="introduce">
      <textarea matInput type="text" [(ngModel)]="msg" cdkTextareaAutosize cdkAutosizeMinRows="1"
        cdkAutosizeMaxRows="5">
      </textarea>
      <mat-label>donate頁面介紹</mat-label>
    </mat-form-field>


    <div>
      <!-- OBS瀏覽器頁面 -->
      <mat-form-field class="settingbtn">
        <mat-label>OBS影片訊息二合一頁面</mat-label>
        <textarea matInput type="text" class="settinginput" id="playUrl" cols="30" rows="10"
          [(ngModel)]="playUrl"></textarea>
      </mat-form-field>
      <button class="copybtn" (click)="alertcopy()" mat-flat-button color="primary"
        [cdkCopyToClipboard]="playUrl">複製到剪貼簿</button>
      <mat-form-field class="settingbtn">
        <mat-label>OBS文字訊息頁面</mat-label>
        <textarea matInput type="text" class="settinginput" id="playDonateUrl" cols="30" rows="10"
          [(ngModel)]="playDonateUrl"></textarea>
      </mat-form-field>
      <button class="copybtn" (click)="alertcopy()" mat-flat-button color="primary"
        [cdkCopyToClipboard]="playDonateUrl">複製到剪貼簿</button>
      <mat-form-field class="settingbtn">
        <mat-label>OBS影片頁面</mat-label>
        <textarea matInput type="text" class="settinginput" id="playVideoUrl" cols="30" rows="10"
          [(ngModel)]="playVideoUrl"></textarea>
      </mat-form-field>
      <button class="copybtn" (click)="alertcopy()" mat-flat-button color="primary"
        [cdkCopyToClipboard]="playVideoUrl">複製到剪貼簿</button>
    </div>
    <div>
      <!-- 觀眾抖內頁面 -->
      <mat-form-field class="settingbtn">
        <mat-label>觀眾抖內頁面</mat-label>
        <textarea matInput type="text" class="settinginput" id="viwerdonateURL" cols="30" rows="10"
          [(ngModel)]="viwerdonateUrl"></textarea>
      </mat-form-field>
      <button class="copybtn" (click)="alertcopy()" mat-flat-button color="primary"
        [cdkCopyToClipboard]="viwerdonateUrl">複製到剪貼簿</button>
    </div>
    <button mat-flat-button id="setting" color="primary" (click)="sendSetting()">儲存設定</button>
    <div id="email">
      <mat-icon id="emailicon">email</mat-icon>
      <span>: support@hibiki-rain.com</span>
    </div>
  </div>
</div>
